import {Component, Input, OnInit} from '@angular/core';
import {CacProfilesApiService} from '../../../../services/api/routing/cac-profiles/cac-profiles-api.service';

@Component({
  selector: 'cac-profiles-configuration',
  templateUrl: './cac-profiles-configuration.component.html',
  styleUrls: ['./cac-profiles-configuration.component.scss']
})
export class CacProfilesConfigurationComponent implements OnInit {

  @Input() isUnauthorized: boolean;
  cacProfilesConfiguration: any = {};

  constructor(private cacProfilesApiService: CacProfilesApiService) { }

  ngOnInit(): void {
    this.cacProfilesApiService.getCacProfilesConfiguration().subscribe(cacProfilesConfiguration => {
      this.cacProfilesConfiguration = cacProfilesConfiguration;
    });
  }

  submit(): void {
    this.cacProfilesApiService.editCacProfilesConfiguration(this.cacProfilesConfiguration)
      .then(() => {}).catch(() => {});
  }

}
